import {combineReducers} from 'redux';
import { reducer as oidcReducer} from 'redux-oidc';
import navigationReducer from './navigation/navigation';
import accountVerificationReducer from './accountVerfication/accountVerification';
import notificationsReducer from './notifications/notifications';
import geoReducer from './geo/geo';
import settingsReducer from './settings/settings';
import plansReducer from './plans/plans';
import billingInformationReducer from './billingInformation/billingInformation';
import subscriptionReducer from './subscription/subscription';
import paymentMethodsReducer from './paymentMethods/paymentMethods';
import invoicesReducer from './invoices/invoices';

const reducer = combineReducers({
    oidc: oidcReducer,
    navigation: navigationReducer,
    accountVerification: accountVerificationReducer,
    notifications: notificationsReducer,
    geo: geoReducer,
    settings: settingsReducer,
    plans: plansReducer,
    billingInformation: billingInformationReducer,
    subscription: subscriptionReducer,
    paymentMethods: paymentMethodsReducer,
    invoices: invoicesReducer
});

export default reducer;